import fileAxios from './fileAxios'

export const files = () => {
  return fileAxios.get(`/files`)
}

export const upload = (file) => {
  const formData=new FormData()
  formData.append("file",file.fileToUpload);
  formData.append("campaignId",file.campaignId);
  formData.append("senderAccount",file.senderAccount);
  return fileAxios.post('/'+file.bankId+`/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',

    }
  })
}

export const reupload = (file) => {
    const formData=new FormData()
    formData.append("file",file.fileToUpload);
    formData.append("fileId",file.fileId);
    return fileAxios.post('/'+file.bankId+'/reupload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',

        }
    })
}

export const download = (data) => {
    return fileAxios.get(`/${data.value.bankId}/${data.value.file}/download`, {
        headers: {
            'Content-Disposition': data.value.header,
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        responseType: 'arraybuffer',
    })
}

export const approve = (idBank,data) => {
  return fileAxios.put(`/`+idBank+`/${data.file}/update`, data, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const approveOtp = (data) => {
  return fileAxios.put(`/${data.file}/update`, data, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}


export const plicks = (file,bankId,page,size) => {
    // let page=0;
    // let size=10;
  return fileAxios.get('/'+bankId+`/${file}/plick`,{ params: {
          page,
          size
      }})
}

export const plick = (bankId,fileId, plickId) => {
  return fileAxios.get('/'+bankId+`/${fileId}/plick/${plickId}`)
}

export const plickUpdate = (bankId,fileId, plickId,plickDetail) => {
  return fileAxios.put('/'+bankId+`/${fileId}/plick/${plickId}/update`,plickDetail)
}

export const send = (data) => {
  return fileAxios.put(`/${data.file}/send`, {"status": data.status}, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const history = (bankId,fileId) => {
  return fileAxios.get(`/${bankId}/${fileId}/history`)
}

export const generalReportApi = (generalReport) =>{
  return fileAxios.post(`/generalreport`, generalReport)
}

export const dashboardFileStats = () => {
  return fileAxios.get('/file/dashboard/stats')
}

export const plickStatusType = () =>{
  return fileAxios.get('/file/statustype')
}

export const fileStatsRequest = (fileStats) =>{
  return fileAxios.post(`/${fileStats.bankId}/file/status/stats`,fileStats)
}

export const plickBankStats = (bankId) =>{
  return fileAxios.get(`/${bankId}/plick/stats`)
}

export const getFilesByCampaign = (files) => {
  return fileAxios.post(`/bycampaign`, files)
}
export const downloadCorporateTemplate=()=>{
  return fileAxios.get(`/download/template`,{
    headers:
        {
          'Content-Disposition': "attachment; filename=Corporate Portal Template 1.0.xlsx",
          // 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
    responseType: 'arraybuffer',
  })
}


export const downloadGeneralReportApi = (generalReport) =>{
  return fileAxios.post(`/generalreport/download`, generalReport,{
        headers:
            {
              'Content-Disposition': "attachment; filename=General Report.xlsx",
              // 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
        responseType: 'arraybuffer',
      }
  )
}

export const downloadGeneralReportDetailsApi = (generalReport) =>{
  return fileAxios.post(`/generalreport/details/download`, generalReport,{
        headers:
            {
              'Content-Disposition': "attachment; filename=General Report Details.xlsx",
              // 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
        responseType: 'arraybuffer',
      }
  )
}

